export default {
  apiKey: 'AIzaSyC6FW_py2UWrTWp0IBVdaQJluDGA1NQQz0',
  authDomain: 'maxxnation-app.firebaseapp.com',
  projectId: 'maxxnation-app',
  storageBucket: 'maxxnation-app.firebasestorage.app',
  messagingSenderId: '807729027096',
  appId: '1:807729027096:web:e5daf93a714b7f4013cb6d',
  measurementId: 'G-NKKVJQ1VCE',
};
